import axios from 'axios';
import headers from "./Header";
let url = 'api/mms/'
class MmsService {
    getData(filter, page) {
        return axios.get(url + 'dataset?filter='+filter+'&page=' + page, {headers: headers()})
    }

    getDataProject(filter, project, page) {
        return axios.get(url + 'dataset/katalog-data?filter='+filter+'&project='+project+'&page=' + page, {headers: headers()})
    }
    getDetailData(id) {
        return axios.get(url + 'detail-dataset/'+id, {headers: headers()})
    }
    getDetailDatasetWithRegionFilter(id,parentRegionId) {
        return axios.get(url + 'detail-dataset/'+id+'/filter?parentRegionId='+parentRegionId, {headers: headers()})
    }

    getControlledVocabullaryItem(query) {
        return axios.get(url + 'controlled-vocabullary-item?query=' + query, {headers: headers()})
    }

    getObjectSlug(slug, page) {
        return axios.get(url + 'object-slug?slug='+slug+'&page=' + page, {headers: headers()})
    }

    getSearch(q) {
        return axios.get(url + 'dataset/' + q, {headers: headers()})
    }

    getSubject() {
        return axios.get(url + 'subjetcs', {headers: headers()})
    }

    getOrganisasi(page) {
        return axios.get(url + 'organization'+(typeof page === 'undefined'?"":"?page="+page), {headers: headers()});
    }

    getSector(){
        return axios.get(url + '/sector', {headers: headers()})
    }

    getCountry(){
        return axios.get(url + '/country', {headers: headers()})
    }

    getDetailBySlug(slug){
        return axios.get(url +'detail-by-slug?slug='+slug, {headers: headers()})
    }
    getContentByObjectSlug(slug,q,page,size){
        let url = 'object-slug?slug='+slug+'&'
        if(q){
            url = url + "q="+q+"&";
        }
        if(page){
            url = url + "page="+page+"&";
        }
        if(size){
            url = url + "size="+size;
        }
        return axios.get(url + url, {headers: headers()})
    }

    getClassificationSeries(){
        return axios.get(url +'reference/classification-series', {headers: headers()})
    }
    getClassificationSeriesDetails(id){
        return axios.get(url +'reference/classification-series/'+id, {headers: headers()})
    }
    getStatisticalClassificationByClassificationSeries(ClassificationSeriesId){
        return axios.get(url +'reference/classification-series/'+ClassificationSeriesId+'/statistical-classifications?size=100', {headers: headers()})
    }
    getStatisticalClassificationDetails(id){
        return axios.get(url +'reference/statistical-classifications/'+id, {headers: headers()})
    }
    getStatisticalClassificationItems(statClassId, levelId, code, name, page, size){
        let query = 'reference/statistical-classifications/'+statClassId+'/items?page='+page+'&size='+size+"&";
        
        if(levelId){
            query = query + "levelId="+levelId+"&";
        }
        if(code){
            query = query + "code="+code+"&";
        }
        if(name){
            query = query + "name="+name;
        }
        
        return axios.get(url + query, {headers: headers()})
    }
    getStatisticalClassificationItemChilds(statClassId, parentId){
        let url = 'reference/statistical-classifications/'+statClassId+'/items?parentId='+parentId;
        return axios.get(url + url, {headers: headers()})
    }
    getCorrespondenceItems(sourceStatisticalClassificationId,targetStatisticalClassificationId,sourceClassificationItemCode){
        let url = 'reference/correspondences?sourceStatisticalClassificationId='+sourceStatisticalClassificationId+'&targetStatisticalClassificationId='+targetStatisticalClassificationId+'&sourceClassificationItemCode='+sourceClassificationItemCode;
        return axios.get(url + url, {headers: headers()})
    }
    getStatisticalProgramCycleDetails(id){
        return axios.get(url +'collection/statistical-program-cycles/'+id, {headers: headers()})
    }
    getVariableDetails(id){
        return axios.get(url +'reference/variables/'+id, {headers: headers()})
    }
    getConceptDetails(id){
        return axios.get(url +'reference/concepts/'+id, {headers: headers()})
    }
    getStatisticalIndicatorDetails(id){
        return axios.get(url +'reference/statistical-indicators/'+id, {headers: headers()})
    }
    getProcessMethodDetails(id){
        return axios.get(url +'reference/process-methods/'+id, {headers: headers()})
    }

    getUnitTypeList(){
        let endp = 'reference/unit-type';
        return axios.get(url +endp, {headers: headers()})
    }

    getMeasurementList(){
        let endp = 'reference/measurement';
        return axios.get(url +endp, {headers: headers()})
    }

    getAllVariable(){
        return axios.get(url + "get-all-variable", {
            headers: headers(),
        });
    }
    getAllIndicator(){
        return axios.get(url + "get-all-indicator", {
            headers: headers(),
        });
    }

    searchVariable (query, page) {
        let endp = "get-all-variable"
        endp += page ? "?page=" + page : "?page=0"
        if (query) {
            endp += "&query=" + query
        }
        return axios.get(url + "" + endp);
    }
    searchIndicator (query, page) {
        let endp = "get-all-indicator"
        if (query != null && page != null) {
            endp = endp + "?query=" + query + "&page=" + page
        }else if (query != null && page == null) {
            endp = endp + "?query=" + query
        }else if (query == null && page != null) {
            endp = endp + "?page=" + page
        }
        return axios.get(url + "" + endp);
    }
    detailVariableIndicator(id){
        return axios.get(url + "get-detail-indicator-variable?id=" + id);
    }
    
}
export default new MmsService();